var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BButton',_vm._b({on:{"click":_vm.cloneItem}},'BButton',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Copy")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }